import api from '../api/offlineClient';
import offlineDB from '../utils/offlineDB';

const VAPID_PUBLIC_KEY = 'BK2nQnNCbVxrE30IaQfUPUk8NF5Gwl6iLLPvDhk8oLkunzDacZ9RrV4Zu9h8wO89eBnGpZ4CzaTrUDFL78ffnhA';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64  = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw     = window.atob(base64);
  return Uint8Array.from([...raw].map(c => c.charCodeAt(0)));
}

class PushService {
  constructor() {
    this._subscribed = false;
  }

  get isSupported() {
    return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
  }

  get permission() {
    return Notification.permission; // 'default' | 'granted' | 'denied'
  }

  async init() {
    if (!this.isSupported) return;
    if (this.permission === 'denied') return;
    if (this.permission === 'granted') {
      await this._subscribe();
    }
    // Si es 'default', esperamos a que el usuario interactúe
  }

  async requestAndSubscribe() {
    if (!this.isSupported) return false;
    if (this.permission === 'denied') return false;
    const result = await Notification.requestPermission();
    if (result !== 'granted') return false;
    return this._subscribe();
  }

  async _subscribe() {
    try {
      const reg = await navigator.serviceWorker.ready;
      let sub = await reg.pushManager.getSubscription();
      if (!sub) {
        sub = await reg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
        });
      }
      // Guardar token en IndexedDB para que el SW pueda usarlo en background sync
      const token = localStorage.getItem('token');
      if (token) await offlineDB.setMeta('token', token);

      // Registrar suscripción en el backend
      await api.post('/api/push/subscribe', { subscription: sub.toJSON() });
      this._subscribed = true;
      return true;
    } catch (err) {
      console.warn('[push] error suscribiendo:', err.message);
      return false;
    }
  }

  async unsubscribe() {
    try {
      const reg = await navigator.serviceWorker.ready;
      const sub = await reg.pushManager.getSubscription();
      if (sub) {
        await api.delete('/api/push/subscribe', { data: { endpoint: sub.endpoint } });
        await sub.unsubscribe();
      }
      this._subscribed = false;
    } catch {}
  }
}

const pushService = new PushService();
export default pushService;
